"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("./waves"));
var install = function install(Vue) {
  Vue.directive('waves', _waves.default);
};
if (window.Vue) {
  window.waves = _waves.default;
  Vue.use(install); // eslint-disable-line
}
_waves.default.install = install;
var _default = exports.default = _waves.default;